export default __webpack_public_path__ + "static/media/logo2.3a0f4ed2.png";